import { render, staticRenderFns } from "./preservationgetDetail.vue?vue&type=template&id=db374d18&scoped=true"
import script from "./preservationgetDetail.vue?vue&type=script&lang=js"
export * from "./preservationgetDetail.vue?vue&type=script&lang=js"
import style0 from "./preservationgetDetail.vue?vue&type=style&index=0&id=db374d18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db374d18",
  null
  
)

export default component.exports